export default __webpack_public_path__ + "static/media/6.e8492469.jpg";